module.exports = __webpack_public_path__ + "static/media/ok.38409ff3.png";